"use client";

import Link from "next/link";
import { useParams, usePathname } from "next/navigation";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import React from "react";


export function MyBreadcrumb({isDisabled,pageUrl, hideLastItem = false }) {
  const pathname = usePathname();
  const { locale } = useParams();
  const pathSegments = pathname
    .split("/")
    .filter((segment) => segment.length > 0)
    .slice(1);  
  
  const displaySegments = hideLastItem
    ? pathSegments.slice(0, -1)
    : pathSegments;

  const buildHref = (index) => "/" + pathSegments.slice(0, index + 1).join("/");
  const capitalize = (str) =>
    str
      .replace(/-/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");


 //Breadcrumb-Shema 
   const disabledLinks = ["checkout", pageUrl];
   const schemaItems = [
        {
         name: "Home",
         url: `https://www.fasttrackvisa.com/${locale}`,
       },
       ...pathSegments.map((segment, index) => {
     const isDisabled = disabledLinks.includes(segment.toLowerCase());
  
    return {
      name: capitalize(decodeURIComponent(segment)),
      url: isDisabled
        ? null
        : `https://www.fasttrackvisa.com/${locale}/${pathSegments
            .slice(0, index + 1)
            .join("/")}`,
    };
  }),
];
 const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: schemaItems.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    ...(item.url ? { item: item.url } : {}),
  })),
}; 
   

  return (
    <>
      <script
          key={pathname} 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(breadcrumbSchema),
          }}
        />
      <div className="max-w-7xl mx-auto py-4 md:py-5">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link href={`/${locale}`} className="font-poppins">
                  Home
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            {displaySegments.map((segment, index) => {
              const isLast = index === displaySegments.length - 1;

              return (
                <React.Fragment key={index}>
                  <BreadcrumbSeparator />
                  <BreadcrumbItem>
                    {isLast && !hideLastItem ? (
                      <BreadcrumbPage className="font-poppins">
                        {capitalize(decodeURIComponent(segment))}
                      </BreadcrumbPage>
                    ) : isDisabled ? (
                      <BreadcrumbPage className="font-poppins text-muted-foreground">
                        {capitalize(decodeURIComponent(segment))}
                      </BreadcrumbPage>
                    ) : (
                      <BreadcrumbLink asChild>
                        <Link href={buildHref(index)} className="font-poppins">
                          {capitalize(decodeURIComponent(segment))}
                        </Link>
                      </BreadcrumbLink>
                    )}
                  </BreadcrumbItem>
                </React.Fragment>
              );
            })}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </>
  );
}
